import { useEffect, useMemo } from "react";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useAuthToken } from "capitalrx-shell";

import { fetch } from "./fetch";
import { useFailureHandler } from "../hooks";


type UseGetHook<Request, Response> = (
  request?: Request,
  options?: Omit<UseQueryOptions, "queryKey">,
) => UseQueryResult<Response, AxiosError>;

export function createQuery<Request, Response>(
  url: string,
): UseGetHook<Request, Response> {
  const failureHandler = useFailureHandler();
  const query = (
    request,
    options,
  ) => {
    const [authToken] = useAuthToken();
    const apiCall = fetch(request, authToken, url);

    const call: UseQueryResult<Response, AxiosError> = useQuery<Response, AxiosError>({
      queryKey: [url, request],
      queryFn: async () => await apiCall,
      ...options,
    });

    useEffect(() => {
      if (call.isError) {
        failureHandler(call.error);
      }
    }, [call.isError]);

    return useMemo(() => call, [call]);
  };

  return query;
}
